/* tslint:disable */
/* eslint-disable */
/**
 * Conversation Service
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const DiseaseEnum = {
    AtopicDermatitis: 'atopic_dermatitis',
    Endometriosis: 'endometriosis',
    LongCovid: 'long_covid',
    MultipleSclerosis: 'multiple_sclerosis',
    MyastheniaGravis: 'myasthenia_gravis',
    ChronicUrticaria: 'chronic_urticaria',
    ChronicHandEczema: 'chronic_hand_eczema',
    ChronicObstructivePulmonaryDisease: 'chronic_obstructive_pulmonary_disease',
    Opade: 'opade',
    ThyroidEyeDisease: 'thyroid_eye_disease',
    GravesDisease: 'graves_disease',
    Insomnia: 'insomnia',
    Psoriasis: 'psoriasis'
} as const;
export type DiseaseEnum = typeof DiseaseEnum[keyof typeof DiseaseEnum];


export function instanceOfDiseaseEnum(value: any): boolean {
    for (const key in DiseaseEnum) {
        if (Object.prototype.hasOwnProperty.call(DiseaseEnum, key)) {
            if (DiseaseEnum[key as keyof typeof DiseaseEnum] === value) {
                return true;
            }
        }
    }
    return false;
}

export function DiseaseEnumFromJSON(json: any): DiseaseEnum {
    return DiseaseEnumFromJSONTyped(json, false);
}

export function DiseaseEnumFromJSONTyped(json: any, ignoreDiscriminator: boolean): DiseaseEnum {
    return json as DiseaseEnum;
}

export function DiseaseEnumToJSON(value?: DiseaseEnum | null): any {
    return value as any;
}

export function DiseaseEnumToJSONTyped(value: any, ignoreDiscriminator: boolean): DiseaseEnum {
    return value as DiseaseEnum;
}

